module.exports = __webpack_public_path__ + "img/fg.cf40dd5d.jpg";